/*
 * @Description: 工具类
 * @Author: jin
 * @Date: 2019-10-15 15:12:21
 */
import '../assets/js/layer/layer'
import '../assets/js/layer/need/layer.css'
import { ImagePreview } from 'vant'
import { pcUrl } from '../config'

// 设置本地信息
export function setLocalInfo (name, content) {
  try {
    if (typeof content !== 'string') {
      content = JSON.stringify(content)
    }
    localStorage.setItem(name, content)
  } catch (e) {}
}

// 读取本地信息
export function getLocalInfo (name) {
  try {
    return localStorage.getItem(name)
  } catch (e) {}
}

// 移出本地缓存
export function removeLocalInfo (name) {
  try {
    localStorage.removeItem(name)
  } catch (e) {}
}

// layer提示信息
export function toast (msg, time) {
  window.layer.open({
    content: msg,
    skin: 'msg',
    time: time || 2
  })
}

// layer弹出框信息
export function showTitleLayer (title, cont) {
  window.layer.open({
    title: title,
    style: 'max-height:450px; overflow-y: auto;',
    content: cont,
  })
}

// layer弹出框信息
export function lookImg (imgList, index) {
  let arr = []
  imgList.map(item => {
    arr.push(pcUrl + item.imgs)
  })
  ImagePreview({
    images: [...arr],
    startPosition: index
  });
}

// 时间戳格式化
export function timeFormat (time = 0, format = 'Y-m-d H:i:s') {
  let date
  if (time) {
    let _time = '' + time
    if (_time.length < 13 || _time.indexOf('.')) {
      time *= 1000
    }
    date = new Date(time)
  } else {
    date = new Date()
  }
  let map = {
    Y: 'getFullYear',
    m: 'getMonth',
    d: 'getDate',
    H: 'getHours',
    i: 'getMinutes',
    s: 'getSeconds'
  }
  for (let i in map) {
    let val = date[map[i]]()
    if (i === 'm') {
      val += 1
    }
    if (val < 10) {
      val = '0' + val
    }
    format = format.replace(i, val)
  }

  return format
}

// 校验手机号码格式是否正确
export function checkMobile (mobile) {
  const filter = /^(13[0-9]|14[5|7]|15[0|1|2|3|5|6|7|8|9]|18[0|1|2|3|5|6|7|8|9])\d{8}$/
  return filter.test(mobile)
}

// 校验邮箱地址格式是否正确
export function checkEmail (email) {
  const filter = /^\w+@[a-zA-Z0-9]{2,10}(?:\.[a-z]{2,4}){1,3}$/
  return filter.test(email)
}

//md5加密
export function md5 (txt) {
  const crypto = require('crypto')
  let md5 = crypto.createHash('md5')
  md5.update(txt)
  return md5.digest('hex')
}



// WEBPACK FOOTER //
// ./src/util/index.js